const initSwitchLanguage = () => {
    const langIcon = document.querySelector("[data-language-selector-container]");
    const dropdownMenuLanguage = document.querySelector("[data-dropdown-lang]");
    langIcon && langIcon.addEventListener('click', () => {
        if (dropdownMenuLanguage.classList.contains('is-visible')) {
            dropdownMenuLanguage.classList.remove('is-visible');
            dropdownMenuLanguage.classList.add('not-visible');
        }
        else {
            dropdownMenuLanguage.classList.remove('not-visible');
            dropdownMenuLanguage.classList.add('is-visible');
        }
    });
};
